// @flow

// React component for a sidenote (guess this'll really be static)

"use strict";

import * as React from 'react';

type Props =  $ReadOnly<{
  footnoteId: string,
  footnoteContent: string,
}>;

function Sidenote({footnoteId, footnoteContent}: Props): React.MixedElement {
  const sidenoteContent = {__html: footnoteContent};
  return (
    <>
      <label className="sidenote-number sidenote-toggle" htmlFor={footnoteId}></label>
      <input className="sidenote-toggle" id={footnoteId} type="checkbox" />
      <span className="sidenote">
        <span className="sidenote-marker" />
        <span className="sidenote-text" dangerouslySetInnerHTML={sidenoteContent} />
      </span>
    </>
  );
}

export default Sidenote;
